import React from "react";
import { HiArrowRight } from "react-icons/hi";
const FeatureItems = ({ item: { icon, title, desc } }) => {
  return (
    <div className="flex items-center px-6 py-4 overflow-hidden rounded-lg shadow-shadowOne bg-gradient-to-r from-primaryColor to-[#202327] group hover:bg-gradient-to-b hover:from-black hover:to-[#1e2024] transition-colors duration-200 group">
      <div className="space-y-3 translate-y-6 group-hover:translate-y-0 transition-transform duration-500">
        <span className="text-secondaryColor text-5xl">{icon}</span>
        <h3 className="text-gray-300 font-bold font-titleFont text-[21px]">
          {title}
        </h3>
        <p>{desc}</p>
        <span className="text-2xl text-secondaryColor inline-block translate-y-20 group-hover:translate-y-0 transition-transform duration-[600ms]">
          <HiArrowRight />
        </span>
      </div>
    </div>
  );
};

export default FeatureItems;
